import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill={props.fill || '#EF3C34'}
        d="M12 13.075a.728.728 0 00.75-.75V7.8c0-.2-.07-.371-.212-.513A.731.731 0 0012 7.075a.728.728 0 00-.75.75v4.525c0 .2.071.37.213.512.141.142.32.213.537.213zm0 3.65a.779.779 0 00.575-.225.779.779 0 00.225-.575.779.779 0 00-.225-.575.779.779 0 00-.575-.225.779.779 0 00-.575.225.779.779 0 00-.225.575c0 .233.075.425.225.575.15.15.342.225.575.225zm0 4.775a9.263 9.263 0 01-3.712-.75 9.58 9.58 0 01-3.013-2.025 9.58 9.58 0 01-2.025-3.013A9.263 9.263 0 012.5 12c0-1.317.25-2.554.75-3.713a9.583 9.583 0 012.025-3.012A9.58 9.58 0 018.288 3.25 9.263 9.263 0 0112 2.5a9.27 9.27 0 013.713.75 9.583 9.583 0 013.012 2.025 9.583 9.583 0 012.025 3.012A9.27 9.27 0 0121.5 12c0 1.317-.25 2.554-.75 3.712a9.58 9.58 0 01-2.025 3.013 9.583 9.583 0 01-3.012 2.025A9.27 9.27 0 0112 21.5z"
      ></path>
    </svg>
  );
}

export default Icon;
